import { PageHeader } from "@shared/components/PageHeader";
import { Card } from "@shared/ui/card";
import { ArrowLeft } from "lucide-react";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import ExecutionDetails from "../details/details";
import PerformanceMetrics from "../performanceMetrics/performanceMetrics";
import { Tabs } from "@shared/ui/tabs";
import EmailLanding from "../tabs/email/landing/landing";
import TextMessageLanding from "../tabs/textMessage/landing/landing";
import { useGetWorkflowsExecutionDetails } from "@features/ux/components/workflow/hooks";

const ExecutionDetailsLanding = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: executionDetails } = useGetWorkflowsExecutionDetails(id);
  return (
    <div>
      <div className="flex items-center gap-4">
        <ArrowLeft
          className="w-5 h-5 cursor-pointer text-gray-700 hover:text-gray-900"
          onClick={() => navigate("/communication-hub/workflows")}
        />
        <div className="flex flex-col">
          <PageHeader
            title="Execution Details"
            subtitle="Comprehensive view of workflow execution"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        <Card className="col-span-8 mt-4">
          <ExecutionDetails data={executionDetails} />
        </Card>
        <div className="col-span-4 mt-4">
          <PerformanceMetrics data={executionDetails} />
        </div>
      </div>
      <div className="flex flex-col space-y-4 mt-3">
        <div className="w-full overflow-hidden">
          <Tabs
            defaultValue="email"
            className="w-full"
            tabsListClassName="grid w-full grid-cols-2 mb-6 p-1"
            urlMapping={{
              email: "email",
              textMessage: "textMessage",
            }}
            tabComponents={{
              email: {
                label: "Email",
                component: <EmailLanding />,
              },
              textMessage: {
                label: "Text Message",
                component: <TextMessageLanding />,
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ExecutionDetailsLanding;
